import React from "react";
import Section from "../components/Section";

function DeviceIdentifier() {
  return (
    <Section id="device-id" icon="📱" title="Device Identifier Usage">
      <p>
        We use a <strong>device identifier</strong> (a unique, non-personal token assigned to your
        device) for three specific purposes:
      </p>

      <h3>1. Application Functionality</h3>
      <p>
        The device identifier allows the App to maintain your session, remember your preferences,
        and provide a consistent experience across App launches — without requiring you to create
        an account or provide any personal information.
      </p>

      <h3>2. App Analytics</h3>
      <p>
        We use the device identifier to understand aggregate usage patterns — such as which features
        are most used, how sessions flow, and where errors occur. This data is used solely to improve
        the App and is never used to identify you personally.
      </p>

      <h3>3. Push Messaging</h3>
      <p>
        The device identifier is associated with your push notification token so that we can deliver
        relevant notifications (e.g., review updates, feature announcements) to your device. You can
        opt out of notifications at any time through your device settings.
      </p>

      <div className="info-box">
        The device identifier we use is a randomly generated token. It is <strong>not</strong> your
        Apple IDFA, Android Advertising ID, or any hardware identifier. It cannot be used to identify
        you as an individual.
      </div>
    </Section>
  );
}

export default DeviceIdentifier;
